// extracted by mini-css-extract-plugin
export default {"_":"Footer____1HD45","sideNav":"Footer_sideNav__CJs2M","logoLx":"Footer_logoLx__cQ7V+","copyright":"Footer_copyright__2WB24"};